
import { Component, Mixins } from 'vue-property-decorator';
import NaviSerchnaviArea from './';
import NaviSerchnaviAreaLinks from '@/components/navi/NaviSerchnaviAreaLinks/NaviSerchnaviAreaLinksEn.vue';
@Component({
  components: {
    NaviSerchnaviAreaLinks,
  },
})
export default class NaviSerchnaviAreaEn extends Mixins(NaviSerchnaviArea) {
}
